module.exports = __webpack_public_path__ + "img/keyboard.a591f802.svg";